import React from 'react';
import Move from '../media/imagen/Move.svg';
import PlusGrey from '../media/imagen/TestPlusGrey.svg';
import DeleteGrey from '../media/imagen/DeleteGrey.svg';

const QuestionCard = ({ question, onSelect, onDeselect, isSelected, disableSelect }) => {
    return (
        <div className={`question-card ${isSelected ? 'selected' : ''}`}>
            <div className="question-content">
                <img 
                    src={Move} 
                    alt="Move Card" 
                    className="move-icon"
                />
                <h4>{question.title}</h4>
            </div>
            
            <div className="action-icons">
                {!isSelected && !disableSelect && onSelect && (
                    <img 
                        src={PlusGrey} 
                        alt="Add question" 
                        className="action-icon" 
                        onClick={() => onSelect(question)} 
                    />
                )}
                
                {isSelected && onDeselect && (
                    <img 
                        src={DeleteGrey} 
                        alt="Remove question" 
                        className="action-icon" 
                        onClick={() => onDeselect(question.id)} 
                    />
                )}
            </div>
        </div>
    );
};

export default QuestionCard;